module.exports = __webpack_public_path__ + "img/247-logo-stacked.1871d261.svg";